export default __webpack_public_path__ + "static/media/bg_location.99354ef8.png";